export class Agent{
    constructor(
        public name: String,
	    public categoria: String,
	    public decription:String,
	    public area: String,
	    public horario: String,
		public time_init: String,
		public time_end: String,
	    public salario: Number,
	    public lugar: String,
    ){}
}